import React from 'react';
import TextField from 'material-ui/TextField';

function ContentSearchModalTitle(props) {
  var clearCurrentSearch = props.clearCurrentSearch,
      closeModal = props.closeModal,
      orgId = props.orgId,
      searchContent = props.searchContent,
      searching = props.searching,
      searchQuery = props.searchQuery,
      searchResults = props.searchResults,
      updateSearchQuery = props.updateSearchQuery,
      usePrevSearch = props.usePrevSearch;
  return /*#__PURE__*/React.createElement("div", {
    style: searchQuery && searchQuery.length > 1 ? {
      padding: 16,
      position: 'relative',
      borderBottom: '1px solid #f1f1f1'
    } : {
      padding: 16,
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon ion-ios-close-empty",
    style: {
      color: '#616161',
      fontSize: 32,
      position: 'absolute',
      top: 0,
      right: 0,
      padding: '0 12px',
      cursor: 'pointer'
    },
    onClick: function onClick() {
      closeModal();
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      position: 'relative',
      width: 256
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    id: "text-field-controlled",
    hintText: "Search",
    floatingLabelText: "Search Content",
    floatingLabelFixed: true,
    value: searchQuery,
    onChange: function onChange(e) {
      updateSearchQuery(orgId, e.target.value);
      searchContent(orgId, e.target.value);
    },
    style: {
      fontSize: 22,
      height: 90,
      paddingRight: 40
    }
  }), !searching && searchQuery.length > 1 && /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#616161',
      fontSize: 20,
      position: 'absolute',
      bottom: 5,
      right: 0,
      padding: 10,
      cursor: 'pointer'
    },
    onClick: function onClick() {
      clearCurrentSearch(orgId);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-times-circle"
  })), searching && /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#616161',
      fontSize: 20,
      position: 'absolute',
      bottom: 5,
      right: 0,
      padding: 10
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-spin"
  }))), searchResults && searchResults.prevResults && !searchResults.currentResults && !searching && searchResults.prevQuery && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      usePrevSearch(orgId);
    },
    style: {
      cursor: 'pointer',
      fontSize: 12,
      margin: '8px auto 0',
      width: 256
    }
  }, "Search for ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'blue'
    }
  }, searchResults.prevQuery), " again?"));
}

ContentSearchModalTitle.defaultProps = {};
export default ContentSearchModalTitle;